module.exports = __webpack_public_path__ + "static/media/kids-t-shirt-500x500.7487bbbc.jpeg";